import { useNativeSessionSync } from '../hooks/useNativeSessionSync';

/** No UI — keeps native Secure Store aligned with web session in the shell. */
export function NativeShellSessionSync() {
  useNativeSessionSync();
  return null;
}
